import { render, staticRenderFns } from "./anzhaocai.vue?vue&type=template&id=5e9556f4&scoped=true"
import script from "./anzhaocai.vue?vue&type=script&lang=js"
export * from "./anzhaocai.vue?vue&type=script&lang=js"
import style0 from "./anzhaocai.vue?vue&type=style&index=0&id=5e9556f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9556f4",
  null
  
)

export default component.exports